/**************************************************
 * Nombre:       Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";

import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import Tarjeta_Testimonio from "../../../Tarjetas/Tarjeta_Testimonio";
import {TESTIMONIOS} from "../../../../Constantes";
import {theme} from "../../../../Tema";
import TextoTitulo from "./TextoTitulo";


const Testimonios = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: theme.palette.primary.main + 10}}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 10}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <TextoTitulo titulo={'TESTIMONIOS DE'} texto={'QUE DICEN DE NOSOTROS'} negrita={'CLIENTES'}
                                 orientacion={'center'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 4}}>
                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: 1,
                            arrows: true,
                            pagination: true,
                            width: '100%',
                            drag: sCell ? false : true,
                            interval: 8000,
                            noDrag: true,
                            type: 'loop',
                            gap: 20,
                            padding: !masSM ? 20 : 300



                        }}
                    >

                        {TESTIMONIOS.map((it, index) => {
                            return (
                                <SplideSlide key={`qe${index}`}>
                                    <Tarjeta_Testimonio item={it}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Testimonios

